import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import { useTranslation } from "react-i18next";


const FeedbackReport = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className="px-2 px-md-4">
                <div className="my-4 col-12 d-flex justify-content-between align-items-center">
                    <h5 className="">{t("Feedback Report")}</h5>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("Academic year")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="academic_year"
                            className="common-input form-select"
                            required
                        >
                            <option value="">Select session</option>
                            <option value="">2022-2023</option>
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("Class Name")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="class"
                            className="common-input form-select"
                        >
                            <option value="">Select class</option>
                            <option value="">12</option>
                            <option value="">11</option>
                            <option value="">10</option>
                            <option value="">09</option>
                            <option value="">08</option>
                            <option value="">07</option>
                            <option value="">06</option>
                            <option value="">05</option>
                            <option value="">04</option>
                            <option value="">03</option>
                            <option value="">02</option>
                            <option value="">01</option>
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("Section Name")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="section"
                            className="common-input form-select"
                        >
                            <option value="">Select section</option>
                            <option value="">A</option>
                            <option value="">B</option>
                            <option value="">C</option>
                        </select>
                    </div>
                </div>

                <div className="row col-6 mt-5 d-flex mx-1">
                    <button type="submit"
                        className="btn btn-primary me-2 col-md-2"
                    >
                        {t("View")}
                    </button>

                    <button
                        type="submit"
                        className="btn btn-secondary me-2 col-md-2"
                    >
                        {t("Cancel")}
                    </button>
                </div>

                <div className="Table mb-4">
                    <TableContainer
                        component={Paper}
                        style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
                        className="my-4"
                    >
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t("Sr. No.")}</TableCell>
                                    <TableCell align="left">{t("Student Name")}</TableCell>
                                    <TableCell align="left">{t("Feedback")}</TableCell>
                                </TableRow>
                            </TableHead>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </>
    );
};

export default FeedbackReport;